import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

export interface DialogData {
  displayName: string;
  jobTitle: string;
  mobilePhone: string;
  company: string;
}

@Component({
  selector: 'app-add-dialog',
  templateUrl: 'adddialog.component.html',
  styleUrls: ['./adddialog.component.css']
})

export class AddDialogComponent implements OnInit {

  Addform: FormGroup;
  displayName: string;
  jobTitle: string;
  mobilePhone: string;
  company: string;

  constructor(private router: Router,
              public dialogRef: MatDialogRef<AddDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData, private fb: FormBuilder) {
    this.displayName = data.displayName;
    this.jobTitle = data.jobTitle;
    this.mobilePhone = data.mobilePhone;
    this.company = data.company;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
    this.initForm();

  }

  initForm() {
    this.Addform = this.fb.group({
      displayName: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(/^([a-zA-Z0-9][a-zA-Z0-9 ]?[a-zA-Z0-9]?)+$/)]],
      jobTitle: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(/^([a-zA-Z0-9][a-zA-Z0-9 ]?[a-zA-Z0-9]?)+$/)]],
      areaCode: ['', [Validators.required, Validators.pattern(/^\+[0-9]{1,6}$/)]],
      mobilePhone: ['', [Validators.required, Validators.pattern(/^[0-9]{5,15}$/)]],
      company: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(/^([a-zA-Z0-9][a-zA-Z0-9 ]?[a-zA-Z0-9]?)+$/)]]
    });
  }

  onAdd() {
    const obj = {
      ...this.Addform.value,
      mobilePhone: this.Addform.controls.areaCode.value + ' ' + this.Addform.controls.mobilePhone.value
    };

    this.dialogRef.close(obj);
  }

  onReset() {
    this.Addform.reset();
  }

  onCancel() {
    this.dialogRef.close();
  }
  areaCodeFocus() {
    if (this.Addform.controls.areaCode.value === '') {
      this.Addform.controls.areaCode.setValue('+');
    }
  }
  areaCodeBlur() {
    if (this.Addform.controls.areaCode.value === '+') {
      this.Addform.controls.areaCode.setValue('');
    }
  }
}
